<template>
  <div>
    <SPGHomePageComponent />    
  </div>
</template>

<script>
import SPGHomePageComponent from "@/common/sgp-components/SGPHomePageComponent" 

export default {
  name: "HomePage",
  components: {
    SPGHomePageComponent
  },
};

</script>